import script from "./ProfileHashtagsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileHashtagsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileHashtagsDrawer.vue?vue&type=style&index=0&id=210ae177&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210ae177"]])

export default __exports__